module.exports = __webpack_public_path__ + "e25074296d459330a565e3c44a35bb01.png";